// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { version } from '../package.json';
export * from './utils';
export * from './components';

import svg4everybody from 'svg4everybody';
svg4everybody();

let baseUrl = '';

if (
    typeof window === 'object'
    && typeof window.require === 'function'
    && typeof window.require.toUrl === 'function'
) {
    baseUrl = window.require.toUrl('plesk-ui-library');
    baseUrl = baseUrl.substr(0, baseUrl.lastIndexOf('/') + 1);
}

/* eslint-disable no-undef, camelcase */
if (typeof __webpack_public_path__ !== 'undefined') {
    __webpack_public_path__ = baseUrl;
}
/* eslint-enable no-undef, camelcase */



// WEBPACK FOOTER //
// ./index.js